export default function(instance) {
  return {
    getServices(data) {
      Object.keys(data).forEach(
        k => !data[k] && data[k] !== undefined && delete data[k]
      );

      return instance.get("/api/payment/services/admin/", { params: data });
    },
    createService(data) {
      return instance.post("/api/payment/services/admin/", {
        name: data.name,
        amount: data.amount,
        date_pay_to: data.date_pay_to,
        user: data.user
      });
    },
    getService(idService) {
      return instance.get(`/api/payment/services/admin/${idService}/`);
    },
    updateService(idService, data) {
      return instance.put(`/api/payment/services/admin/${idService}/`, {
        name: data.name,
        amount: data.amount,
        date_pay_to: data.date_pay_to,
        comment: data.comment
      });
    },
    deleteService(idService) {
      return instance.delete(`/api/payment/services/admin/${idService}/`);
    }
  };
}
